import LoadableImage from "../LoadableImage";
import Navigation from "../Navigation";
import BackLink from "../BackLink";
import ForwardLink from "../ForwardLink";
import {useEffect} from "react";

function Page31() {
  useEffect(() => {
    document.title = "Маяк — Страница 30"
  }, []);

  return (
    <>
      <Navigation />

      <div className="NavigationLink-wrapper">
        <BackLink href="/page29" />
        <ForwardLink href="/page31" />
      </div>

      <p style={{ textAlign: "right" }}>30.</p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Хорошо, хорошо... меня вполне<br/>
        устраивает, Эфраим Уинслоу. Итак, что<br/>
        привело такого как ты на этот
        проклятый камень?
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Такого как?
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Красивого как картинка.
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        --
      </p>
      <p>СТАРИК смеется от души.</p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Просто прикалываюсь, парень, просто прикалываюсь--
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Уинслоу.
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Уинслоу -- Что привело тебя на этот
        камень, Эфраим Уинслоу? Чем<br/>
        промышлял до этого?
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Лесом.
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Лесом...
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Большим лесом. На севере. На дорогах в Канаду.
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Наряд Гудзонова залива?
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Тоже.
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Правда ли говорят? “Лес далеко,<br/>
        насколько хватает глаз.”
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Дасэр. Ель, тамарак... белая<br/>
        сосна. “Буш”, — называют это<br/>
        местные.
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Хватит с тебя деревьев, что ли?
      </p>
      <p style={{ textAlign: "right" }}>30.</p>
      
      <Navigation />
      
      <div className="NavigationLink-wrapper">
        <BackLink href="/page29" />
        <ForwardLink href="/page31" />
      </div>

      <LoadableImage
        src="https://res.cloudinary.com/linuxmachinecloud/image/upload/v1710020696/the-lighthouse-script/czwe8vjmr4horpp6ltmw.jpg"
        alt="Иллюстрация"
      />
    </>
  );
}

export default Page31;
